import React, { useState } from "react";
import Button from "../Button";
import Link from "../Link";
import { isEqual } from "underscore";

export default function EditPrice({ price, originalPrice, updatePrice }) {
  const hasChanged = !isEqual(price, originalPrice);

  return (
    <span>
      <input
        type="number"
        value={price.price}
        onChange={e => updatePrice({ ...price, price: e.target.value })}
        size={8}
        style={{
          width: 90,
          border: hasChanged ? "2px solid green" : null,
          borderRadius: 5,
          textAlign: "center"
        }}
      />
      &nbsp;
      <input
        type="checkbox"
        onChange={e => updatePrice({ ...price, ignore_turnaround_premium: e.target.checked })}
        checked={price.ignore_turnaround_premium}
      />{" "}
      Ignore Turnaround Premium? &nbsp;
      {hasChanged && (
        <Link onClick={() => updatePrice(originalPrice)}>
          <i className="fa fa-refresh" />
        </Link>
      )}
    </span>
  );
}
